const SOPS_INITIAL_STATE = {
  fetchingError: undefined,
  isFetching: false,
  creatingError: undefined,
  isCreating: false,
  data: [],
}

export default SOPS_INITIAL_STATE
